import { Fragment, h } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import { tryParse } from '@pes-ui/utils';
import { PesRouterStore } from '../../index';
import { addHostToHmcUrls } from '../UI/help-me-choose/utils';
import { getFilteredBreadcrumbs } from '../breadcrumbs/utils';
export class PesAppSubcategory {
  constructor() {
    this._showBreadcrumbs = undefined;
    this._subcategoryData = undefined;
    this._subcategoryId = undefined;
    this._countryCode = undefined;
    this._languageCode = undefined;
    this._isPBS = undefined;
    this.host = undefined;
    this.subcategoryId = undefined;
    this.showBreadcrumbs = undefined;
    this.subcategoryData = null;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.isPBS = true;
    this.hostWithLocale = '';
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f;
    this.showBreadcrumbs = (_a = tryParse(this._showBreadcrumbs)) !== null && _a !== void 0 ? _a : this.showBreadcrumbs;
    this.subcategoryData = (_b = tryParse(this._subcategoryData)) !== null && _b !== void 0 ? _b : this.subcategoryData;
    this.subcategoryId = (_c = tryParse(this._subcategoryId)) !== null && _c !== void 0 ? _c : this.subcategoryId;
    this.countryCode = (_d = tryParse(this._countryCode)) !== null && _d !== void 0 ? _d : this.countryCode;
    this.languageCode = (_e = tryParse(this._languageCode)) !== null && _e !== void 0 ? _e : this.languageCode;
    this.isPBS = (_f = tryParse(this._isPBS)) !== null && _f !== void 0 ? _f : this.isPBS;
    if (this.isPBS)
      PesRouterStore.set('enableAppRouting', true);
    this.hostWithLocale = `${this.host}${this.countryCode}/${this.languageCode}/`;
  }
  get customBreadcrumbs() {
    if (!this.showBreadcrumbs) {
      return null;
    }
    return {
      breadcrumbs: getFilteredBreadcrumbs(this.subcategoryData.subcategoryBreadcrumbs.breadcrumbs, this.isPBS ? undefined : []),
    };
  }
  get hmcBanner() {
    var _a;
    if (!((_a = this.subcategoryData) === null || _a === void 0 ? void 0 : _a.hmcBanner)) {
      return {};
    }
    const { hmcBanner } = this.subcategoryData;
    addHostToHmcUrls(this.host, hmcBanner);
    return hmcBanner;
  }
  render() {
    const { subcategoryBreadcrumbs: { hideOnMobile }, subcategoryDescription: { name, description, readLessLabel, readMoreLabel }, subcategoryRanges: { rangePartofLabel, rangeProductsViewDetailsLabel, productRelationsViewProdLabel, viewOnLabel, ranges, subCatagoryProductRangeLabel, avoidAccents, }, } = this.subcategoryData;
    const { sourceId, categoryName, parentCategoryId, hasQuestionnaire, categoryProductConfiguratorUrl, questionnaireUrl, rangeTooltipUrl, selectorConfigUrl, labels, host, token, channel, pageSource, } = this.hmcBanner;
    return (h(Fragment, null, h("div", { class: "subcategories__main" }, this.showBreadcrumbs && (h("pes-breadcrumbs", Object.assign({}, this.customBreadcrumbs, { hideOnMobile: hideOnMobile, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs", hostWithLocale: this.hostWithLocale }))), h("header", null, h("pes-category-description", { name: name, description: description, readMoreLabel: readMoreLabel, readLessLabel: readLessLabel })), !this.isPBS && (h("slot", { name: "content-article-slide-carousel" })), h("main", null, !isEmpty(this.hmcBanner) && (h("div", { class: "hmc-banner-container" }, h("pes-hmc-banner", { sourceId: sourceId, categoryName: categoryName, parentCategoryId: parentCategoryId, hasQuestionnaire: hasQuestionnaire, categoryProductConfiguratorUrl: categoryProductConfiguratorUrl, questionnaireUrl: questionnaireUrl, rangeTooltipUrl: rangeTooltipUrl, selectorConfigUrl: selectorConfigUrl, labels: labels, hmcHost: host, token: token, channel: channel, pageSource: pageSource }))), h("pes-category-range-list", { rangePartofLabel: rangePartofLabel, rangeProductsViewDetailsLabel: rangeProductsViewDetailsLabel, productRelationsViewProdLabel: productRelationsViewProdLabel, viewOnLabel: viewOnLabel, ranges: ranges, subCatagoryProductRangeLabel: subCatagoryProductRangeLabel, avoidAccents: avoidAccents, hostWithLocale: this.hostWithLocale, subcategoryId: this.subcategoryId })))));
  }
  static get is() { return "pes-app-subcategory"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-app-subcategory.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-app-subcategory.css"]
    };
  }
  static get properties() {
    return {
      "_showBreadcrumbs": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-breadcrumbs",
        "reflect": false
      },
      "_subcategoryData": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-subcategory-data",
        "reflect": false
      },
      "_subcategoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-subcategory-id",
        "reflect": false
      },
      "_countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-country-code",
        "reflect": false
      },
      "_languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-language-code",
        "reflect": false
      },
      "_isPBS": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-is-pbs",
        "reflect": false
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "https://www.se.com:9090"
            }],
          "text": "The host of the endpoints."
        },
        "attribute": "host",
        "reflect": false
      },
      "subcategoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "4040"
            }],
          "text": "The ID of the subcategory."
        },
        "attribute": "subcategory-id",
        "reflect": false
      },
      "showBreadcrumbs": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether to show the breadcrumbs."
        },
        "attribute": "show-breadcrumbs",
        "reflect": false
      },
      "subcategoryData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSubcategoryData",
          "resolved": "{ configuration: TConfig; subcategoryBreadcrumbs: TBreadcrumbsData; subcategoryDescription: TDescriptionInfo; hmcBanner: THMCBanner; subcategoryRanges: TRangesData; recentlyViewedConfig: RecentlyViewedConfig; metaTags?: MetaTags; }",
          "references": {
            "TSubcategoryData": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Main data for subcategory page."
        },
        "defaultValue": "null"
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "fr"
            }],
          "text": "The code of the country of the app."
        },
        "attribute": "country-code",
        "reflect": false
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "it"
            }],
          "text": "The code of the language of the app."
        },
        "attribute": "language-code",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "true"
      }
    };
  }
  static get states() {
    return {
      "hostWithLocale": {}
    };
  }
}
